import { render, staticRenderFns } from "./QuestionSave.vue?vue&type=template&id=197940fa"
import script from "./QuestionSave.vue?vue&type=script&lang=js"
export * from "./QuestionSave.vue?vue&type=script&lang=js"
import style0 from "./QuestionSave.vue?vue&type=style&index=0&id=197940fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports